/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGarageIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-garage"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.88 22.8Q2.75 22.8 1.99 22.04Q1.23 21.27 1.23 20.15L1.23 3.85Q1.23 2.75 1.99 1.98Q2.75 1.2 3.88 1.2L20.18 1.2Q21.27 1.2 22.05 1.98Q22.82 2.75 22.82 3.85L22.82 20.15Q22.82 21.27 22.05 22.04Q21.27 22.8 20.18 22.8ZM9.03 14.1Q9.03 14.1 8.8 14.1Q8.57 14.1 8.25 13.78Q7.92 13.45 7.92 13Q7.92 12.55 8.25 12.22Q8.57 11.9 9.03 11.9Q9.47 11.9 9.8 12.22Q10.13 12.55 10.13 13Q10.13 13.45 9.8 13.78Q9.47 14.1 9.03 14.1ZM15.03 14.1Q15.03 14.1 14.8 14.1Q14.57 14.1 14.25 13.78Q13.93 13.45 13.93 13Q13.93 12.55 14.25 12.22Q14.57 11.9 15.03 11.9Q15.47 11.9 15.8 12.22Q16.13 12.55 16.13 13Q16.13 13.45 15.8 13.78Q15.47 14.1 15.03 14.1ZM5.8 18.85Q6.28 18.85 6.6 18.52Q6.92 18.2 6.92 17.73L6.92 16.8L17.13 16.8L17.13 17.73Q17.13 18.2 17.45 18.52Q17.77 18.85 18.25 18.85Q18.73 18.85 19.05 18.52Q19.38 18.2 19.38 17.73L19.38 11.5Q19.38 11.28 19.34 11.05Q19.3 10.82 19.23 10.63L17.98 6.95Q17.7 6.15 17.01 5.65Q16.32 5.15 15.47 5.15L8.57 5.15Q7.72 5.15 7.04 5.65Q6.35 6.15 6.08 6.95L4.83 10.63Q4.75 10.82 4.71 11.05Q4.67 11.28 4.67 11.5L4.67 17.73Q4.67 18.2 5 18.52Q5.33 18.85 5.8 18.85ZM7.67 9.25L8.32 7.4Q8.32 7.4 8.32 7.4Q8.32 7.4 8.32 7.4L15.72 7.4Q15.72 7.4 15.72 7.4Q15.72 7.4 15.72 7.4L16.38 9.25Z" fill={color} />
    </svg>
  );
}
